import React, { useEffect, useState } from 'react'
import styles from './restosList.m.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const publisherDomain = parseHostname().publicationDomain

export const RestosList = ({
  restos,
  handleClick
}: {
  restos: []
  handleClick: () => void
}) => {
  const countStep = 10
  const [showCount, setShowCount] = useState(countStep)
  const [sortedRestos, setSortedRestos] = useState([])

  useEffect(() => {
    setSortedRestos(
      restos
        .sort((a, b) => a.ts - b.ts)
        .sort((a, b) => {
          if (publisherDomain === 'tdg.ch') {
            if (a.longitude < 6.37557) return -1
          } else {
            if (a.longitude >= 6.37557) return -1
          }
        })
    )
  }, [restos])

  return (
    <div className={styles.restosListContainer}>
      <div className={styles.restosResultTitle}>
        Nous {sortedRestos.length === 0 ? "n'" : ''}avons trouvé{' '}
        {sortedRestos.length === 0 ? 'aucun' : sortedRestos.length} buvette
        {sortedRestos.length > 1 ? 's' : ''}.
      </div>
      {/* <div className={styles.title}>Notre liste de restaurants</div> */}
      {sortedRestos.slice(0, showCount).map(resto => (
        <div
          key={`resto-${resto.markerId}`}
          className={styles.restoContainer}
          onClick={() => {
            handleClick(resto)
          }}
        >
          <div className={styles.imageContainer}>
            <div
              style={{
                backgroundImage: `url(${require(`../../images/illu-test-${1 +
                  Math.floor(Math.random() * 4)}.png`)})`
              }}
              className={styles.image}
            />
          </div>
          <div className={styles.restoContent}>
            <div className={styles.restoTitle}>{resto.title}</div>
            <div className={styles.restoDescription}>{resto.description}</div>
            <div className={styles.link}>En lire davantage →</div>
          </div>
        </div>
      ))}
      <div className={styles.moreBtnContainer}>
        {sortedRestos.length > showCount && (
          <div
            className={styles.moreBtn}
            onClick={() => {
              setShowCount(showCount + countStep)
            }}
          >
            Voir davantage de buvettes
          </div>
        )}
      </div>
    </div>
  )
}
